<template>
  <div class="page-contact">
    <section class="page-contact__form-section">
      <div class="form-section container">
        <h1 class="form-section__title">{{ $t('title') }}</h1>

        <div class="form-section__wrapper">
          <div class="form-section__column form-section__form">
            <div class="form__container container">
              <h2 class="form__title">{{ $t('form_title') }}</h2>

              <ContactForm :confirmation-path="$t('confirmation_path')" />
            </div>
          </div>

          <div class="form-section__column form-section__info">
            <h3 class="info__title">
              {{ $t('consumer_title') }}
            </h3>
            <p class="info__body">
              {{ $t('consumer_body') }}
            </p>

            <h3 class="info__title">
              {{ $t('professional_title') }}
            </h3>
            <p class="info__body">
              {{ $t('professional_body') }}
              <nuxt-link class="text-primary" :to="$t('professional_link')">
                {{ $t('here') }}
              </nuxt-link>
              {{ $t('professional_body_continued') }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <div
      v-if="showBambeloCrossSell"
      class="page-contact__cross-sell"
      :style="{
        backgroundImage: `url('${require('chimera/all/assets/images/bambelo.jpg')}')`,
      }"
    >
      <div class="cross-sell container">
        <div class="cross-sell__wrapper">
          <h2 class="cross-sell__title">
            {{ $t('cross_sell_title') }}
          </h2>

          <p class="cross-sell__body">
            {{ $t('cross_sell_body') }}
          </p>

          <t-btn-link
            id="linkToBambelo"
            class="cross-sell__link"
            :href="$t('cross_sell_link')"
            target="_blank"
          >
            {{ $t('cross_sell_button') }}
          </t-btn-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactForm from 'chimera/all/components/form/contact/ContactForm'

export default {
  name: 'ContactPage',

  components: {
    ContactForm,
  },

  computed: {
    /**
     * @returns {boolean}
     */
    showBambeloCrossSell() {
      return this.$store.getters['context/get']('country') === 'nl'
    },
  },
}
</script>

<i18n>
{
  "nl": {
    "title": "Klantenservice",
    "form_title": "Neem contact met ons op!",
    "confirmation_path": "/contact-opnemen/bevestigd",
    "consumer_title": "Ben je een consument en heb je een vraag?",
    "consumer_body": "Vul het contactformulier in en wij nemen binnen 24 uur contact met je op. Ook als je verbeterpunten voor ons hebt, horen wij dat natuurlijk graag.",
    "professional_title": "Ben je een professional en heb je interesse in het ontvangen van offerte-aanvragen?",
    "professional_body": "Wij verzorgen een constante stroom aan nieuwe klanten. Neem",
    "here": "hier",
    "professional_body_continued": "contact met ons op. Vul het contactformulier in en wij nemen binnen 24 uur contact met je op.",
    "professional_link": "/contact-opnemen-bedrijf",
    "cross_sell_title": "Bespaar ook op de kosten van andere diensten",
    "cross_sell_body": "Ga nu naar Bambelo.com en vind gratis en vrijblijvend de beste deals van meer dan 2.000 geselecteerde professionals.",
    "cross_sell_button": "Ga naar Bambelo.com",
    "cross_sell_link": "https://www.bambelo.com"
  },
  "nl-BE": {
    "title": "Klantenservice",
    "form_title": "Neem contact met ons op!",
    "confirmation_path": "/contact-opnemen/bevestigd",
    "consumer_title": "Bent u een consument en heeft u een vraag?",
    "consumer_body": "Vul het contactformulier in en wij nemen binnen 24 uur contact met u op. Ook verbeterpunten horen wij natuurlijk graag.",
    "professional_title": "Bent u een professional en geïnteresseerd in offerte-aanvragen?",
    "professional_body": "Wij zorgen voor een constante stroom aan nieuwe klanten. Neem",
    "here": "hier",
    "professional_body_continued": "contact met ons op. Vul het contactformulier in en wij nemen binnen 24 uur contact met u op.",
    "professional_link": "/contact-opnemen-bedrijf",
    "cross_sell_title": "Bespaar ook op andere diensten",
    "cross_sell_body": "Bezoek nu Bambelo.com en vind gratis en vrijblijvend de beste deals van meer dan 2.000 geselecteerde professionals.",
    "cross_sell_button": "Bezoek Bambelo.com",
    "cross_sell_link": "https://www.bambelo.com"
  },
  "fr-FR": {
    "title": "Service clientèle",
    "form_title": "Contactez-nous!",
    "confirmation_path": "/contact/confirme",
    "consumer_title": "Vous êtes consommateur et vous avez une question?",
    "consumer_body": "Remplissez le formulaire de contact et nous vous contacterons dans les 24 heures. Si vous avez des suggestions d'amélioration, n'hésitez pas à nous en faire part.",
    "professional_title": "Vous êtes un professionnel et souhaitez recevoir des demandes de devis?",
    "professional_body": "Nous assurons un flux constant de nouveaux clients. Contactez-nous",
    "here": "ici.",
    "professional_body_continued": "Remplissez le formulaire de contact et nous vous contacterons dans les 24 heures.",
    "professional_link": "/contact-entreprise",
    "cross_sell_title": "Économisez également sur d'autres services",
    "cross_sell_body": "Rendez-vous maintenant sur Bambelo.com et trouvez gratuitement les meilleures offres de plus de 2 000 professionnels sélectionnés.",
    "cross_sell_button": "Rendez-vous sur Bambelo.com",
    "cross_sell_link": "https://www.bambelo.com"
  },
  "fr-BE": {
    "title": "Service clientèle",
    "form_title": "Contactez-nous!",
    "confirmation_path": "/contact/confirme",
    "consumer_title": "Vous êtes consommateur et vous avez une question?",
    "consumer_body": "Remplissez le formulaire de contact et nous vous contacterons dans les 24 heures. Si vous avez des suggestions d'amélioration, n'hésitez pas à nous en faire part.",
    "professional_title": "Vous êtes un professionnel et souhaitez recevoir des demandes de devis?",
    "professional_body": "Nous assurons un flux constant de nouveaux clients. Contactez-nous",
    "here": "ici.",
    "professional_body_continued": "Remplissez le formulaire de contact et nous vous contacterons dans les 24 heures.",
    "professional_link": "/contact-entreprise",
    "cross_sell_title": "Économisez également sur d'autres services",
    "cross_sell_body": "Rendez-vous maintenant sur Bambelo.com et trouvez gratuitement les meilleures offres de plus de 2 000 professionnels sélectionnés.",
    "cross_sell_button": "Rendez-vous sur Bambelo.com",
    "cross_sell_link": "https://www.bambelo.com"
  },
  "de-DE": {
    "title": "Kundendienst",
    "form_title": "Nehmen Sie Kontakt mit uns auf!",
    "confirmation_path": "/kontakt-aufnehmen/bestatigt",
    "consumer_title": "Sie sind Verbraucher und haben eine Frage?",
    "consumer_body": "Füllen Sie das Kontaktformular aus und wir werden Sie innerhalb von 24 Stunden kontaktieren. Wir freuen uns auch von Ihnen zu hören, wenn Sie Verbesserungsvorschläge haben.",
    "professional_title": "Sind Sie ein Spezialist und an Angebotsanfragen interessiert?",
    "professional_body": "Wir sorgen für einen konstanten Zustrom von Neukunden. Kontaktieren Sie uns",
    "here": "hier",
    "professional_body_continued": ". Füllen Sie das Kontaktformular aus und wir werden Sie innerhalb von 24 Stunden kontaktieren.",
    "professional_link": "/kontakt-fur-unternehmen",
    "cross_sell_title": "Sparen Sie auch bei anderen Dienstleistungen",
    "cross_sell_body": "Besuchen Sie jetzt Bambelo.com und finden Sie kostenlos die besten Angebote von mehr als 2.000 ausgewählten Fachleuten.",
    "cross_sell_button": "Besuchen Sie Bambelo.com",
    "cross_sell_link": "https://www.bambelo.com"
  },
  "es-ES": {
    "title": "Servicio al cliente",
    "form_title": "Contacta con nosotros",
    "confirmation_path": "/contacto/confirmado",
    "consumer_title": "¿Eres un consumidor y tienes una pregunta?",
    "consumer_body": "Rellena el formulario de contacto y en menos de 24 horas nos pondremos en contacto contigo. Si tienes alguna sugerencia nos encantará escucharla.",
    "professional_title": "¿Eres un profesional y tienes interés en recibir solicitudes de presupuesto?",
    "professional_body": "Os proporcionaremos un flujo constante de clientes potenciales. Contacta con nosotros",
    "here": "aquí.",
    "professional_body_continued": "Rellena el formulario y nos pondremos en contacto contigo en un plazo de 24 horas.",
    "professional_link": "/contacto-pro",
    "cross_sell_title": "Ahorra también en otros servicios",
    "cross_sell_body": "Visita ahora Bambelo.com y encuentra gratuitamente las mejores ofertas de más de 2.000 profesionales seleccionados.",
    "cross_sell_button": "Ir a Bambelo.com",
    "cross_sell_link": "https://www.bambelo.com"
  },
  "it-IT": {
    "title": "Servizio clienti",
    "form_title": "Contattaci!",
    "confirmation_path": "/contattaci/confermato",
    "consumer_title": "Sei un cliente e hai una domanda?",
    "consumer_body": "Compila il modulo e ti contatteremo entro 24 ore. Per qualsiasi suggerimento su come migliorarci, non esitare a comunicarcelo.",
    "professional_title": "Sei un professionista e sei interessato a ricevere un preventivo?",
    "professional_body": "Ci prendiamo cura di un continuo flusso di nuovi clienti.",
    "here": "Contattaci qui",
    "professional_body_continued": "Compila il modulo di contatto e ti risponderemo entro 24 ore.",
    "professional_link": "/contattare-azienda",
    "cross_sell_title": "Risparmia anche su altri servizi",
    "cross_sell_body": "Visita subito Bambelo.com e trova gratuitamente le migliori offerte di oltre 2.000 professionisti selezionati.",
    "cross_sell_button": "Visita Bambelo.com",
    "cross_sell_link": "https://www.bambelo.com"
  }
}
</i18n>
